/**
 *
 * PureModeCourseCpnt
 *
 */

import { mapState, mapGetters, mapActions } from 'vuex';

import Swal from 'sweetalert2';

import PureModeCourse from '@/scripts/PureMode/PureModeCourse';

import { OpenStudentworkModalMixin } from '@/mixins/Studentwork/OpenStudentworkModal';

export default {
  name: 'PureModeCourseCpnt',

  mixins: [PureModeCourse, OpenStudentworkModalMixin],

  data() {
    return {};
  },

  computed: {
    ...mapState({
      ms_isDebug: 'isDebug',
    }),

    ...mapState('MainModeCourse', {
      MainModeCourse_ms_isRequest: 'isRequest',
    }),

    ...mapGetters({
      PureModeCourse_mg_isRequest: 'PureModeCourse/isRequest',
    }),

    c_courseId() {
      return this.CourseId;
    },

    c_isCpntRequest() {
      return !this.MainModeCourse_ms_isRequest && this.PureModeCourse_mg_isRequest;
    },

    c_isHaveCurrentBook() {
      return this.lastRecord.bookId;
    },
  },

  methods: {
    ...mapActions('MainModeCourse', {
      ma_getCourseTaskStatus: 'getCourseTaskStatus',
    }),

    ///
    noAccessInfo(objBookReading) {
      if (!objBookReading.canAccess) {
        Swal.fire({
          width: '400px',
          backdrop: false,
          icon: 'warning',
          title: `没有权限`,
          text: '亲爱的学员您还没有购买该课程, 购买课程后再来吧～',
          showConfirmButton: false,
          timer: 1500,
        });
      } else if (objBookReading.c_isLockedByStudentWorkStatus) {
        Swal.fire({
          width: '400px',
          backdrop: false,
          icon: 'warning',
          title: `温馨提示`,
          text: '亲爱的学员，请先完成全部前置章节的作业提交以解锁当前章节～',
          showConfirmButton: false,
          timer: 1500,
        });
      }
    },

    gotoBook(book) {
      if (!book.c_isCanStudy) {
        this.noAccessInfo(book);
      } else {
        this.$router.push(`/video-mode-course/${this.CourseId}/book/${book.bookId}`);
      }
    },

    gotoReading(book, reading) {
      if (!reading.c_isCanStudy) {
        this.noAccessInfo(reading);
      } else {
        this.$router.push(
          `/video-mode-course/${this.CourseId}/book/${book.bookId}/reading/${reading.readingId}`
        );
      }
    },

    getCourseTaskStatus() {
      this.ma_getCourseTaskStatus({
        courseId: this.CourseId,
      });
    },

    _PureModeCourseCpntCreated() {
      this.getCourseTaskStatus();
    },
  },

  created() {
    this._PureModeCourseCpntCreated();
  },
};
